/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { getPayloadObject, getTelemetryAttributes, ITelemetryContent } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

export interface ICheckoutTermsAndConditionsCheckboxProps {
    isChecked: boolean;
    ariaLabel?: string;
    disabled: boolean;
    id?: string;
    telemetryContent?: ITelemetryContent;
    onChange(event: React.ChangeEvent<HTMLInputElement>): void;
}

/**
 * AddPaymentForm SFC.
 * @param root0
 * @param root0.isChecked
 * @param root0.ariaLabel
 * @param root0.disabled
 * @param root0.telemetryContent
 * @param root0.onChange
 * @param root0.id
 * @extends {React.FC<ICheckoutTermsAndConditionsCheckboxProps>}
 */
const CheckoutTermsAndConditionsCheckbox: React.FC<ICheckoutTermsAndConditionsCheckboxProps> = ({
    isChecked,
    ariaLabel,
    disabled,
    telemetryContent,
    onChange,
    id
}) => {
    const payLoad = getPayloadObject('click', telemetryContent!, '');
    const attribute = getTelemetryAttributes(telemetryContent!, payLoad);

    return (
        <>
            <input
                className='ms-checkout-terms-and-conditions__input-checkbox'
                type='checkbox'
                aria-label={ariaLabel}
                aria-checked={isChecked}
                name='checkoutTermsAndConditions'
                onChange={onChange}
                disabled={disabled}
                checked={isChecked}
                id={id}
                {...attribute}
            />
        </>
    );
};

export default CheckoutTermsAndConditionsCheckbox;
